import { Component, Input, OnInit } from '@angular/core';
import { ImportConfigurationTransferType, ImportProtocolDTO, ImportSuccessState } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-import-configuration-protocol-edit-form-header',
    templateUrl: './import-configuration-protocol-edit-form-header.component.html',
    styleUrls: ['./import-configuration-protocol-edit-form-header.component.scss'],
    imports: [NgClass, DatePipe, TranslateModule]
})
export class ImportConfigurationProtocolEditFormHeaderComponent {
  @Input()
  public protocol: ImportProtocolDTO;

  public get succeededOn() : Date {
    if (this.protocol?.successState === ImportSuccessState.Fixed || this.protocol?.successState === ImportSuccessState.Success) {
      return this.protocol.modifiedOn.toJSDate();
    }
    return null;
  }

  public get successState(): string {
    if (this.protocol?.successState == null) {
      return null;
    }
    return 'i18n.domain.import-configuration.enums.success-state.' + ImportSuccessState[this.protocol.successState];
  }

  public get hasError(): boolean {
    return this.protocol?.successState === ImportSuccessState.Error;
  }

  public get type(): string {
    if (this.protocol?.transferType == null) {
      return null;
    }
    return 'i18n.domain.import-configuration.enums.transfer-type.' + ImportConfigurationTransferType[this.protocol.transferType];
  }

  constructor() { }

}
